import TimeoutImg from '@/assets/imgs/timeout-icon.svg';

import Auxiliary from '../Auxiliary';

interface TimeoutProps {
  handleClose: () => void;
}

export default function Timeout({ handleClose }: TimeoutProps) {
  return (
    <Auxiliary
      screen="timeout"
      title="Tu sesión ha caducado"
      subtitle="Vuelve a intentarlo nuevamente"
      imgSrc={TimeoutImg}
      mainButton="Volver"
      handleMainButton={() => handleClose()}
    />
  );
}
